import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const InputDate = ({ input, placeholder, type, className, beforeInput, afterInput, initvalue, val, min, max, meta: { asyncValidating, touched, error } }) => {

  return (
    <div className={asyncValidating ? 'async-validating' : ''}>
      <div >
        {beforeInput}
        <DatePicker {...input} type={type} autoComplete="off" showMonthDropdown showYearDropdown placeholder={placeholder} className={className} minDate={ min } defaultValue={initvalue} value={val} min={min} max={max}  inputValueFormat="DD/MM/YYYY" dateFormat='DD/MM/YYYY' selected={input.value ? moment(input.value, 'DD/MM/YYYY')  : moment() } />
        {afterInput}
      </div>
      {touched && error && <div><span className="text-danger">{error}</span></div>}
    </div>
  );
}

export default InputDate;



// WEBPACK FOOTER //
// ./src/lib/forms/inputDate.js